import React, { useState, useCallback } from "react";
import { groupBy } from "./questionsUtils";
import { SingleCategoryView } from "./SingleCategoryView";
import { AllCategoriesView } from "./AllCategoriesView";
import { InitialView } from "./InitialView";

type Question = {
  id: string;
  client?: string;
  trial?: string;
  role: string;
  question: string;
  category: string;
};

type CategorizedQuestionsListProps = {
  questions: Question[];
  handleSuggestedQuestions: (question: string) => void;
  onClickExploreMore: () => void;
  onCloseExploreMore: () => void;
};

export default function CategorizedQuestionsList({
  questions,
  handleSuggestedQuestions,
  onClickExploreMore,
  onCloseExploreMore,
}: CategorizedQuestionsListProps) {
  const [showDetails, setShowDetails] = useState(false);
  const [showSingleCategory, setShowSingleCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const handleClickMore = useCallback(() => {
    onClickExploreMore();
    setShowDetails(true);
    setShowSingleCategory(false);
    setSelectedCategory(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
  }, []);

  const handleClickSingle = useCallback((categoryKey: string) => {
    setShowDetails(true);
    setShowSingleCategory(true);
    setSelectedCategory(categoryKey);
  }, []);

  const handleClose = useCallback(() => {
    onCloseExploreMore();
    setShowDetails(false);
    setShowSingleCategory(false);
    setSelectedCategory(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
  }, []);

  const groupedQuestions = groupBy(questions, "category");
  const selectedCategoryData = groupedQuestions.find(
    (category) => category.key === selectedCategory,
  );

  if (!groupedQuestions || groupedQuestions.length === 0) {
    return (
      <div className="flex items-center justify-center p-8 text-gray-500">
        <p>No questions available at the moment.</p>
      </div>
    );
  }

  if (showDetails) {
    if (showSingleCategory && selectedCategoryData) {
      return (
        <SingleCategoryView
          categoryData={selectedCategoryData}
          onClose={handleClose}
          onSelectQuestion={handleSuggestedQuestions}
        />
      );
    }

    return (
      <AllCategoriesView
        categories={groupedQuestions}
        onClose={handleClose}
        onSelectQuestion={handleSuggestedQuestions}
      />
    );
  }

  return (
    <InitialView
      categories={groupedQuestions}
      onCategoryClick={handleClickSingle}
      onExploreMore={handleClickMore}
    />
  );
}
